import React from 'react'
import Grid from '@material-ui/core/Grid'

import Content from 'components/shared/Content'
import * as beacon from 'utils/beacon'

interface Props {
  sensor: any
}

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const Cryo = ({sensor}: Props) => {
  const level = beacon.calcLevel(sensor, sensor.settings)

  return (
    <Grid container direction="column">
      <Grid item>
        <Content style={style} label="Raw" value={`${(sensor.sensor1 / 100).toFixed(1)} mA`} />
      </Grid>
      <Grid item>
        <Content style={style} label="Level" value={`${(level * 100).toFixed(1)} %`} />
      </Grid>
    </Grid>
  )
}

export default Cryo
